module.exports = __webpack_public_path__ + "img/specpath-icon.0b762f3e.png";